// Small labels shared by the coach components.

/** Accessible name for the coach presence in each state. */
export const glyphLabel = (state, count) => {
  if (state === "thinking") return "Coach, working";
  if (count > 0)
    return `Coach, ${count} ${count === 1 ? "thing needs" : "things need"} you`;
  return "Coach";
};

/** "Week of Oct 26" from an ISO date. */
export const weekLabel = (iso) => {
  const d = new Date(`${iso}T00:00:00Z`);
  return Number.isNaN(d.getTime())
    ? iso
    : `Week of ${d.toLocaleDateString([], { month: "short", day: "numeric", timeZone: "UTC" })}`;
};
